import { Directive, HostBinding, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[am-layout-container]',
})
export class LayoutContainerDirective implements OnInit {
  @HostBinding('style.height') _hostHeight: string;
  @Input() containerHeight = '100%';

  ngOnInit() {
    this._hostHeight = this.containerHeight;
  }
}
